/**
 * @generated SignedSource<<ea135c05b9a14af72a5d22620c9f0fb3>>
 * @relayHash c016556e72569ab657c5e3a254837505
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21f327fb0e284e5d01ec30368cc8072723b032febd2d59391a7592ddfc308efe

import type { ConcreteRequest, Query } from 'relay-runtime';
export type uiGetPaymentDetailsEnteredQuery$variables = {
  cloudId: string;
};
export type uiGetPaymentDetailsEnteredQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly transactionAccounts: ReadonlyArray<{
      readonly isBillToPresent: boolean | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
};
export type uiGetPaymentDetailsEnteredQuery = {
  response: uiGetPaymentDetailsEnteredQuery$data;
  variables: uiGetPaymentDetailsEnteredQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiGetPaymentDetailsEnteredQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "transactionAccounts",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiGetPaymentDetailsEnteredQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "transactionAccounts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "21f327fb0e284e5d01ec30368cc8072723b032febd2d59391a7592ddfc308efe",
    "metadata": {},
    "name": "uiGetPaymentDetailsEnteredQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bf1b0ce0772fcd76c5314e9d886ff131";

export default node;
